import React, { useState, useRef, useEffect } from 'react';

import { TimeLineItem } from './components/TimeLineItem';
import { Header } from './components/Header';

import { naomiTimeline } from './data/naomiTimeline';

import bookTrailer from "./assets/booktrailer.mp4";

import './App.scss';



const timelineExpanders = naomiTimeline.map((year, index) => {
  const expanded = index === 0;
  return {
    ...year,
    expanded,
  }
});

export const App = () => {
  const [timeline, setTimeLine] = useState(timelineExpanders);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const containerWidth = useRef({ scrollWidth: 2, offsetWidth: 1 });

  useEffect(() => {
    containerWidth.current.scrollWidth = document.querySelector('.timeline-container').scrollWidth;
    containerWidth.current.offsetWidth = document.querySelector('.timeline-container').offsetWidth;
  })

  const handleItemToggle = (event, index) => {
    if ((event.type === "keydown" && event.key === "Enter") || event.type === "click") {
      const updatedItems = [...timeline];
      updatedItems[index].expanded = !updatedItems[index].expanded;
      setTimeLine(updatedItems);
      setSelectedIndex(index);
    }
  };


  const handleScroll = (e) => {
    if (e.target.scrollLeft > 0) {
      setScrollLeft(e.target.scrollLeft);
    }
  }


  const canScroll = scrollLeft < (containerWidth.current.scrollWidth - containerWidth.current.offsetWidth);

  return (
    <div className={`app ${canScroll ? 'scroll-indicator' : ''}`}>
      <Header quote={timeline[selectedIndex].quote} />
      <div className="timeline-container" onScroll={handleScroll}>
        <div>
          <video src={bookTrailer} controls />
          <div className="promo">
            <a href="http://www.lauralam.co.uk/book/goldilocks/">
              Buy Goldilocks by Laura Lam
            </a>
          </div>
        </div>
        {timeline.map((year, index) => {
          return (
            <TimeLineItem
              year={year}
              key={year.age}
              onClick={(e) => handleItemToggle(e, index)}
              onKeyDown={(e) => handleItemToggle(e, index)}
            />
          )
        })}
      </div>
    </div>
  );
};
